export const ALTERAR_MEDICO_EXECUTANTE = 'ALTERAR_MEDICO_EXECUTANTE';
export const alterarMedicoExecutante = (medicoExecutante) => ({
  type: ALTERAR_MEDICO_EXECUTANTE,
  payload: {
    medicoExecutante,
  },
});



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/material/recebimento.action.js